import React from "react";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

const SummaryTableSkeleton = () => {
  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        marginTop: "1px",
        width: "100%",
        marginRight: 1,
      }}
    >
      <Box
        sx={{
          maxHeight: "650px",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "5px",
            height: "3px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f0f0f0",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#c0c0c0",
            borderRadius: "10px",
            minHeight: "2px",
          },
        }}
      >
        {/* Fund Select Dropdown */}
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box sx={{ width: "15%", padding: 2 }}>
            <Skeleton
              variant="rectangular"
              width={80}
              height={20}
              sx={{ borderRadius: 1 }}
            />
          </Box>
          <Box sx={{ width: "20%", padding: 2 }}>
            <Skeleton
              variant="rectangular"
              width={160}
              height={20}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        </Box>
        

        {/* Table */}
        <Table
          size="small"
          stickyHeader
          aria-label="a dense table"
          sx={{
            borderCollapse: "collapse",
            border: "solid 1px #eee",
            marginTop: "-1px",
          }}
        >
          {/* SUMMARY Header */}
          <thead>
            <TableRow>
              <TableCell
                colSpan={10}
                align="center"
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "8px 0",
                }}
              >
                SUMMARY
              </TableCell>
            </TableRow>
            {/* First header row - merged categories */}
            <TableRow>
              <TableCell
                align="center"
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "4px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={40} height={16} />
              </TableCell>
              <TableCell
                colSpan={3}
                align="center"
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "4px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={60} height={16} />
              </TableCell>
              <TableCell
                colSpan={3}
                align="center"
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "4px", 
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={40} height={16} />
              </TableCell>
              <TableCell
                colSpan={3}
                align="center"
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "4px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={50} height={16} />
              </TableCell>
            </TableRow>
            {/* Second header row - individual column headers */}
            <TableRow>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={35} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={40} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={30} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={35} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={40} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={30} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={35} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={40} height={14} />
              </TableCell>
              <TableCell
                align="center"
                style={{
                  fontSize: "11px",
                  padding: "2px",
                  borderLeft: "0.1px solid rgb(36, 35, 35)",
                  borderRight: "0.1px solid rgb(36, 35, 35)",
                }}
              >
                <Skeleton variant="text" width={30} height={14} />
              </TableCell>
            </TableRow>
          </thead>

          {/* Table Body */}
          <TableBody>
            {/* Buy Long Row */}
            <TableRow>
              <TableCell
                align="left"
                style={{
                  fontSize: "12px",
                  paddingLeft: "5px",
                  borderLeft: "none",
                  borderRight: "none",
                  fontWeight: "bold",
                }}
              >
                <Skeleton variant="text" width={70} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
            </TableRow>

            {/* Sell Long Row */}
            <TableRow>
              <TableCell align="left" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={70} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
            </TableRow>

            {/* Sell Short Row */}
            <TableRow>
              <TableCell align="left" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={70} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
            </TableRow>

            {/* Cover Short Row */}
            <TableRow>
              <TableCell align="left" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={70} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
            </TableRow>

            {/* Total Row - Highlighted */}
            <TableRow sx={{}}>
              <TableCell align="left" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={70} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={25} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
              <TableCell align="right" style={{ fontSize: "12px", paddingLeft: "5px", borderLeft: "none", borderRight: "none", fontWeight: "bold" }}>
                <Skeleton variant="text" width={30} height={16} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default SummaryTableSkeleton;
